import React from 'react'
import ImageWrap from 'components/ImageWrap'
import PageLink from 'components/PageLink'
import { isObjectEmpty } from 'js/utils'

export default function ImageCopyBlock({ content }) {
  const { image, title, body, button } = content?.imageCopyBlock

  return (
    <section className='img-copy image-copy-block'>
      <div className='img-copy__wrap '>
        <div className='img-copy__img'>
          <ImageWrap image={image} />
        </div>
        <div className='img-copy__copy'>
          <div className='img-copy__copy-wrap'>
            <h3 className='img-copy__copy__title'>{title}</h3>

            <div
              className='img-copy__copy__excerpt'
              dangerouslySetInnerHTML={{ __html: body }}
            />
            {!isObjectEmpty(button) && (
              <PageLink pageLink={button.pageLink} className='hero__cta'>
                {button.pageLinkText}
              </PageLink>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}
